import React from 'react';

import { ICoSettlementAgentObj } from '../../../../../types/SettlementAgent';
import InviteCoSaItem from '../InviteCoSaItem';
import InviteCoSaPreview from '../InviteCoSaPreview';

export interface IAddCoSa {
  isReviewing?: boolean;
  maxCapacity: number;
  orderType: string;
  existingCoSa: any;
  existingSettlementAgentsOnTheOrder: string[];
  setIsListValid: (isValid: boolean) => void;
  confirmChecked: (checked: boolean) => void;
  listPreview?: Map<number, ICoSettlementAgentObj>;
  setPreview: (map: Map<number, ICoSettlementAgentObj>) => void;
  getExistingSettlementAgentByEmail: (email: string) => any;
}

const InviteCoSaPanel = (props: IAddCoSa) => {
  const {
    isReviewing,
    orderType,
    maxCapacity,
    existingCoSa,
    setIsListValid,
    confirmChecked,
    listPreview,
    existingSettlementAgentsOnTheOrder,
    setPreview,
    getExistingSettlementAgentByEmail,
  } = props;

  return (
    <>
      {!isReviewing ? (
        <InviteCoSaItem
          orderType={orderType}
          existingSettlementAgentsOnTheOrder={
            existingSettlementAgentsOnTheOrder
          }
          setAllValid={(isAllValid) => setIsListValid(isAllValid)}
          coSaToPreview={listPreview}
          onUserChange={(answerMap) => setPreview(answerMap)}
          existingCoSa={existingCoSa}
          getExistingSettlementAgentByEmail={getExistingSettlementAgentByEmail}
          maxCapacity={maxCapacity}
        />
      ) : (
        <InviteCoSaPreview
          coSaListToPreview={listPreview}
          confirmChecked={(checked) => confirmChecked(checked)}
        />
      )}
    </>
  );
};

export default InviteCoSaPanel;
